import styled, { css } from 'styled-components';
import { FieldWrapper, FieldLabel, HelperText } from '../TextField/index.style';

type FieldSize = 'sm' | 'md';

interface FieldProps {
  $hasError?: boolean;
  $fullWidth?: boolean;
  $size?: FieldSize;
}

export { FieldWrapper, FieldLabel, HelperText };

export const FieldSelect = styled.select<FieldProps>`
  border-radius: ${props => props.theme.radii.md};
  border: 1px solid
    ${props =>
      props.$hasError ? props.theme.colors.danger : props.theme.colors.border};
  background: ${props => props.theme.colors.surface};
  padding: ${props =>
    props.$size === 'sm'
      ? `${props.theme.spacing.xs} ${props.theme.spacing.md}`
      : `${props.theme.spacing.sm} ${props.theme.spacing.md}`};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  color: ${props => props.theme.colors.textPrimary};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: ${props => (props.$fullWidth ? '100%' : 'auto')};
  min-height: ${props => (props.$size === 'sm' ? '36px' : '40px')};

  &:focus {
    outline: none;
    border-color: ${props =>
      props.$hasError ? props.theme.colors.danger : props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }

  ${props =>
    props.$hasError &&
    css`
      background: rgba(214, 69, 69, 0.04);
    `}
`;
